import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { Button } from '@mui/material';
import { useState } from 'react';
import { FinanceDashboardAgingReservesChart } from '../charts/FinanceDashboardAgingReservesChart';

export const FinanceDashboardAgingReservesCard = ({ startPeriod, endPeriod, periodicity, prodIds, channelIds }) => {

  const [stacked, setStacked] = useState(true);

  return (
    <DashboardCard
      title="Reserves Aging"
      buttons={
        <Button
          variant="contained"
          onClick={() => setStacked((prev) => !prev)}
        >
          {stacked ? 'Separate' : 'Stacked'}
        </Button>
      }
    >
      <FinanceDashboardAgingReservesChart
        entity="RESERVE"
        chartType="AGE"
        startPeriod={startPeriod}
        endPeriod={endPeriod}
        periodicity={periodicity}
        prodIds={prodIds}
        channelIds={channelIds}
        stacked={stacked}
      />
    </DashboardCard>
  )
}